import { watcher as commonWatcher } from "./api/watchers";
import { commonSlice, commonReducer } from "./model/slice";
import {
  selectUserCart,
  selectActiveTab,
  selectIsLoading,
  selectCurrentUser,
  selectActiveEntity,
  selectClientCompany,
  selectNavigationTabs,
  selectActiveParentEntity,
} from "./model/selectors";
import {
  useActions as useCommonActions,
  sagaActions as commonSagaActions,
} from "./api/actions";

/**
 *  @commonSlice - slice's actions, use for saga only.
 *  @commonReducer - slice's reducer, using for combine reducers.
 **/
export { commonReducer, commonSlice };

/**
 *  @commonWatcher - saga watcher, using for run saga.
 *  @useCommonActions - custom hook, using for dispatching actions in functional components.
 *  @commonSagaActions - list of actions, using for dispatching actions in sagas.
 **/
export { commonWatcher, useCommonActions, commonSagaActions };

/**
 * @description selectors list for getting state from redux store.
 **/
export {
  selectUserCart,
  selectActiveTab,
  selectIsLoading,
  selectCurrentUser,
  selectActiveEntity,
  selectClientCompany,
  selectNavigationTabs,
  selectActiveParentEntity,
};

export const { setActiveEntity, setActiveParentEntity } = commonSlice;

